export default (holder) => {
  const regex = /[a-zA-Z]/;
  const notOnlyLetters = regex.test(holder);

  if (notOnlyLetters === false) {
    return false;
  }

  return true;
};
